import script from "./file-upload-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./file-upload-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./file-upload-setting-ly.vue?vue&type=style&index=0&id=cfacda42&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfacda42"]])

export default __exports__